import http from "@/services/http";

const get = (params) => http.get(`commissions`, { params: params })
const update = (id, dataForm) => http.put(`commissions/${id}`, dataForm)

export default {
  get,
  update,
}
